function getCurrentState(setState) {
    return new Promise((res) => {
        setState((state) => {
            res(state);
            return state;
        });
    });
}

export { getCurrentState };
//# sourceMappingURL=getCurrentState.js.map
